import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.isMobile ? _setup.CoreBottomSheet : _setup.CoreDialog,
    _vm._b(
      {
        tag: "component",
        attrs: { "data-qa": "preliminary_consultation_modal" },
        scopedSlots: _vm._u(
          [
            !_setup.isMobile
              ? {
                  key: "prependBtn",
                  fn: function ({ btnProps }) {
                    return [
                      _c(
                        VBtn,
                        _vm._b(
                          {
                            on: {
                              click: function ($event) {
                                _setup.invasiveServiceInfoStore.isOpenedPreliminaryConsultationModal = false
                              },
                            },
                          },
                          "v-btn",
                          btnProps,
                          false
                        ),
                        [
                          _c("span", {
                            staticClass: "ui-icon-close-not-a-circle",
                          }),
                        ]
                      ),
                    ]
                  },
                }
              : null,
            {
              key: "default",
              fn: function ({ xSpaceClass, counterXSpaceClass }) {
                return [
                  _c(VImg, {
                    staticClass: "mx-auto mb-5",
                    attrs: {
                      contain: "",
                      width: "280",
                      height: "168",
                      src: "/static/_v1/pd/mascots/doctor-checking-pulse.svg",
                      alt: "Доктор проверяющий пульс - ПроДокторов",
                      "data-qa": "preliminary_consultation_img",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "text-h6 text--text text-center mb-2",
                      attrs: { "data-qa": "preliminary_consultation_title" },
                    },
                    [
                      _vm._v(
                        "\n      Сначала нужно проконсультироваться с врачом\n    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "text-body-1 text-secondary--text text-center",
                      attrs: { "data-qa": "preliminary_consultation_subtitle" },
                    },
                    [
                      _vm._v(
                        "\n      Он проверит наличие противопоказаний и при их отсутствии сможет выписать направление\n    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _setup.invasiveServiceInfoStore.allowTreatmentReferral &&
                  !(
                    _setup.invasiveServiceInfoStore
                      .requiresPrimaryConsultation &&
                    _setup.invasiveServiceInfoStore
                      .hasPrimaryConsultationDoctors
                  ) &&
                  _setup.invasiveServiceInfoStore.doctorSpecialities.length
                    ? [
                        _c(
                          "div",
                          {
                            staticClass: "text-subtitle-1 text--text mt-5 mb-4",
                          },
                          [
                            _vm._v(
                              "\n        Выберите врача в вашем городе\n      "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          VList,
                          { class: counterXSpaceClass },
                          _vm._l(
                            _setup.invasiveServiceInfoStore.doctorSpecialities,
                            function (speciality) {
                              return _c(
                                VListItem,
                                {
                                  key: speciality.name,
                                  class: xSpaceClass,
                                  attrs: { dense: "", href: speciality.url },
                                },
                                [
                                  _c(
                                    VListItemIcon,
                                    { staticClass: "align-self-center" },
                                    [
                                      _c("span", {
                                        staticClass:
                                          "ui-icon-doctor icon-secondary--text",
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    VListItemContent,
                                    [
                                      _c(VListItemTitle, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text-body-1 text--text",
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(speciality.name) +
                                                "\n              "
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(VListItemAction, [
                                    _c("span", {
                                      staticClass:
                                        "ui-icon-arrow-right icon-secondary--text",
                                    }),
                                  ]),
                                ],
                                1
                              )
                            }
                          ),
                          1
                        ),
                      ]
                    : _vm._e(),
                ]
              },
            },
            _setup.invasiveServiceInfoStore.requiresPrimaryConsultation &&
            _setup.invasiveServiceInfoStore.hasPrimaryConsultationDoctors
              ? {
                  key: "actions",
                  fn: function () {
                    return [
                      _c(
                        VBtn,
                        {
                          class: { "order-1 w-100": _setup.isMobile },
                          attrs: {
                            text: "",
                            color: "text",
                            "data-qa": "preliminary_consultation_btn_cancel",
                          },
                          on: {
                            click: function ($event) {
                              _setup.invasiveServiceInfoStore.isOpenedPreliminaryConsultationModal = false
                            },
                          },
                        },
                        [_vm._v("\n      Закрыть\n    ")]
                      ),
                      _vm._v(" "),
                      _c(
                        VBtn,
                        {
                          staticClass:
                            "branding-btn branding-btn--primary rounded-20 text-none",
                          class: { "w-100": _setup.isMobile },
                          attrs: {
                            depressed: "",
                            color: "primary",
                            "data-qa": "preliminary_consultation_btn_continue",
                          },
                          on: {
                            click:
                              _setup.invasiveServiceInfoStore.handleAppointment,
                          },
                        },
                        [_vm._v("\n      Записаться к врачу\n    ")]
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
          ],
          null,
          true
        ),
        model: {
          value:
            _setup.invasiveServiceInfoStore
              .isOpenedPreliminaryConsultationModal,
          callback: function ($$v) {
            _vm.$set(
              _setup.invasiveServiceInfoStore,
              "isOpenedPreliminaryConsultationModal",
              $$v
            )
          },
          expression:
            "invasiveServiceInfoStore.isOpenedPreliminaryConsultationModal",
        },
      },
      "component",
      _setup.isMobile ? { slotActionsClass: "flex-column" } : { size: "lg" },
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }